export default {
  "content": "<path d=\"M17.5 19.5a2 2 0 114 0 2 2 0 01-4 0zM17.5 3.5a2 2 0 114 0 2 2 0 01-4 0zM10 10.5v-7a1 1 0 011-1h5v2h-4v14.001h4v2h-5a1 1 0 01-1-1V12.5H7v-2h3zM1.5 11.5a2 2 0 114 0 2 2 0 01-4 0z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};